import React, { useEffect, useState } from "react";
import styles from "../../_css/SessionCategoryManagement.module.css";
import Categories from "./Categories";
import Sessions from "./Sessions";
import TrainAIPopup from "../TrainModule/TrainAIPopup";
import ChatPopup from "../UI/ChatPopup";
import VoiceChatPopup from "../Modals/VoiceChatPopup";
import { useSelector, useDispatch } from "react-redux";
import { closePopup } from "../../_store/reducers/trainAIPopupReducer";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { getSessions } from "../../requests";
import { deleteAuthToken } from "../../utils/helper";
import useDebounce from "../hooks/useDebounce";

const headers = ["Session Title", "Created Date", "Status", "Visiblity"];

function Index() {
  const [showChat, setShowChat] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [visibilityFilter, setVisibilityFilter] = useState(99);
  const [data, setData] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [dateFilter, setDateFilter] = useState({});
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    limit: 5,
  });

  const dispatch = useDispatch();
  const { show: showAIPopup } = useSelector((state) => state.trainAIPopup);
  const { refreshSession } = useSelector((state) => state.refreshSessionData);

  const debouncedSearchValue = useDebounce(searchValue, 300);



  useEffect(() => {
    if (selectedCategory?.sessionCount > 0) {
      // Reset search when category changes
      setSearchValue("");
      fetchSessions();
    } else {
      setData({});
    }
  }, [selectedCategory, refreshSession, visibilityFilter, dateFilter]);

  useEffect(() => {
    if (selectedCategory?.sessionCount > 0) {
      fetchSessions();
    }
  }, [pageInfo]);

  useEffect(() => {
    if (!showChat && selectedCategory?.sessionCount > 0) {
      fetchSessions();
    }
  }, [showChat]);

  // Effect to handle debounced search
  useEffect(() => {
    if (
      selectedCategory?.sessionCount > 0 &&
      debouncedSearchValue !== undefined
    ) {
      fetchSessions();
    }
  }, [debouncedSearchValue, selectedCategory]);

  const fetchSessions = async () => {
    dispatch(startLoader());
    console.log("selectedCategory", selectedCategory);
    try {
      const response = await getSessions({
        categoryId: selectedCategory?.id,
        page: pageInfo.page,
        limit: pageInfo.limit,
        visibility: visibilityFilter,
        search: debouncedSearchValue,
        dateFilter,
      });

      const rows = response.data.sessions;
      const pagination = response.data.pagination;

      setData({
        headers,
        rows,
        pagination,
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };

  const handleOpenChat = (mode) => {
    setShowChat(mode);
    dispatch(closePopup());
  };

  const handlePageChange = (newPage, limit = 5) => {
    setPageInfo({
      page: newPage,
      limit: limit,
    });
    // fetchSessions(newPage, limit);
  };

  const handleVisibilityFilter = (value) => {
    setVisibilityFilter(value);
    // Reset to first page when filter changes
    if (selectedCategory?.sessionCount > 0) {
      fetchSessions(1, 5);
    }
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const handleDateFilterChange = (value) => {
    setDateFilter(value);
  };

  return (
    <div className={styles.homeContainer}>
      <TrainAIPopup
        show={showAIPopup}
        onHide={() => dispatch(closePopup())}
        onOpenChat={handleOpenChat}
        modelTitle="Add Session"
      />
      <ChatPopup
        show={showChat === "text"}
        onClose={() => setShowChat(false)}
        isNewSession={true}
      />
      <VoiceChatPopup
        show={showChat === "voice"}
        onClose={() => setShowChat(false)}
        isNewSession={true}
      />
      <Categories
        styles={styles}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
      <Sessions
        styles={styles}
        data={data}
        category={selectedCategory}
        onPageChange={handlePageChange}
        onVisibilityFilter={handleVisibilityFilter}
        onSearchChange={handleSearchChange}
        searchValue={searchValue}
        onDateFilterChange={handleDateFilterChange}
      />
    </div>
  );
}

export default Index;
